import { Component, Event, EventEmitter, h, Prop, State } from "@stencil/core";

export interface ISidebarItem {
    id: string;
    title: string;
    subtitle: string;
    date: string;
    isActive?: boolean;
}

@Component({
    tag: "sis-sidebar",
    styleUrl: "sis-sidebar.scss",
    shadow: true
})
export class SisSidebar {
    @Prop() readonly items: ISidebarItem[] = [];
    @Prop() readonly activeItemId: string = "";

    @Event() selectItem: EventEmitter<string>;

    @State() internalItems: ISidebarItem[] = [];

    componentWillLoad() {
        this.updateInternalItems();
    }

    componentWillRender() {
        this.updateInternalItems();
    }

    private updateInternalItems() {
        this.internalItems = this.items.map((item) => ({
            ...item,
            isActive: item.id === this.activeItemId
        }));
    }

    private handleItemClick = (id: string) => {
        this.selectItem.emit(id);
    };

    private handleKeyDown = (e: KeyboardEvent, id: string) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            this.selectItem.emit(id);
        }
    };

    render() {
        return (
            <div class="sis-sidebar">
                <div class="sidebar-header">
                    <div class="logo">
                        <img
                            width="60"
                            height="60"
                            src="https://www.trumpf.com/_assets/c6f81dd72b876bbc6ea1c443ba1feb37/Images/nav/logo.png"
                            alt="TRUMPF Logo"
                        />
                    </div>
                    <ux-button
                        class="new-chat-button"
                        variant="primary"
                        icon="plus"
                        onClick={() => this.handleItemClick("new-chat")}
                        aria-label="New chat"
                    >
                        New Chat
                    </ux-button>
                </div>
                <div class="sidebar-content">
                    {this.internalItems.length === 0 ? (
                        <div class="empty-state">No conversations available</div>
                    ) : (
                        <ul class="sidebar-items">
                            {this.internalItems.map((item) => (
                                <li
                                    class={{
                                        "sidebar-item": true,
                                        active: item.isActive
                                    }}
                                    tabIndex={0}
                                    aria-selected={item.isActive}
                                    onClick={() => this.handleItemClick(item.id)}
                                    onKeyDown={(e) => this.handleKeyDown(e, item.id)}
                                >
                                    <div class="title">{item.title}</div>
                                    <div class="meta-info">
                                        <div class="subtitle">{item.subtitle}</div>
                                        <div class="date">{item.date}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}
